import { useRef, useCallback, memo } from "react";
import { useEffect } from "react";
import { useEditorContext } from "../EditorContext";
import { CKCONFIG } from "../config";
import { toRGBA } from "../parser/utils";

// Here need to set the default width auto for the pasted table
function handleTableWithAuto(pastedData) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(pastedData, 'text/html');
  const handleTables = doc.querySelectorAll('table');
  
  handleTables.forEach(table => {
    table.style.width = 'auto';
  });
  
  return doc.documentElement.outerHTML;
}

export const useInlineEditor = (ref, config = {}) => {
  const editorRef = useRef();

  const { addSubscriber, removeSubscriber, notifySubscriber } = useEditorContext();

  const editorControl = useCallback(() => {
    if (!editorRef.current && ref.current) {
      ref.current.setAttribute("contenteditable", "true");
      CKEDITOR.config.allowedContent = true;
      CKEDITOR.disableAutoInline = true;
      const editor = CKEDITOR.inline(ref.current, { ...CKCONFIG, ...config });
      editor.on("change", () => {
        const text = editor.getData();
        if (config.onEditorDataChange) {
          config.onEditorDataChange(text);
          notifySubscriber("DATA_CHANGE");
        }
      });
      editor.on('paste', function(evt) {
        // The handling here is to handle some special situations
        var pastedData = evt.data.dataValue;
        evt.data.dataValue = handleTableWithAuto(pastedData);

      });
      editorRef.current = editor;
    }
  }, [notifySubscriber]);

  useEffect(() => {
    // subscribe select node;
    addSubscriber({ type: "NODE_SELECT", fn: editorControl });
    return () => {
      removeSubscriber(editorControl);
    };
  }, [addSubscriber, removeSubscriber]);

  useEffect(() => {
    return () => {
      if (editorRef.current) {
        editorRef.current.destroy();
      }
    };
  }, []);

}

const TextEditorWrapper = memo(({data}) => {

  const { editorOptions } = useEditorContext();

  const ref = useRef();

  useInlineEditor(ref, {
    onEditorDataChange: (html) => {
      data.html = html;
    },
    mergetags: editorOptions.mergeTag,
  });

  return (
    <div
      style={{ padding: 0 }}
      ref={ref}
      dangerouslySetInnerHTML={{ __html: data.html }}
    />
  );
});

export default ({ data }) => {
  const { paddingTop, paddingBottom, paddingRight, paddingLeft, backgroundColor } = data;

  const ref = useRef();

  useInlineEditor(ref, {
    onEditorDataChange: (html) => {
      data.html = html;
    },
  });

  return (
    <div style={{ paddingTop, paddingBottom, paddingRight, paddingLeft, backgroundColor: toRGBA(backgroundColor), }}>
      <TextEditorWrapper data={data}/>
    </div>
  );
};
